import React, { useContext, useState } from 'react';
import { Navbar, Nav, NavDropdown } from 'react-bootstrap';
import { NavLink, useHistory } from 'react-router-dom';
import styled from 'styled-components';
import { Colors } from '../../scss/common/style';
import MyContext from '../../services/context';
import UserLocalService from '../../services/logic/userService';
import logo from '../../static/img/logo.svg';
import arrow from '../../static/img/arrow.svg';
import userIcon from '../../static/img/userIcon.svg';
import MaskGroup from '../../static/img/MaskGroup.svg';
import { PRODUCTION, STAGING } from '~/src/utils/constants';
import RolesDependent from '~/src/components/common/RolesDependent';
import { ROLES } from '~/src/utils/constants';
import SvilaClientApi from '~/src/services/api/SvilaClientApi';

export default function MainNavigation(): JSX.Element {
  const history = useHistory();
  const [active, setACtive] = useState(0);
  const context = useContext(MyContext);

  const logout = () => {
    UserLocalService.logout();
    const newUser = UserLocalService.getUser();
    context.setUser(newUser);
    history.push('/');
  };

  const NavItem = ({ children, number }) => {
    return <WrapperNavLink isActive={number == active}>{children}</WrapperNavLink>;
  };

  return (
    <MyContext.Consumer>
      {() => (
        <>
          {context.user?.isAuthenticated && (
            <StyledNavbar expand="lg">
              <Navbar.Toggle aria-controls="basic-navbar-nav" />
              <StyledNavbarColapse id="basic-navbar-nav">
                {/* <StyleBackground /> */}
                <Navbar.Brand href="#home">
                  <MaskGroupWrapper>
                    <MaskGroupImage src={MaskGroup} />
                  </MaskGroupWrapper>
                  <NavLink
                    style={{ position: 'relative' }}
                    onClick={() => setACtive(0)}
                    className="navbar-brand"
                    to="/home/"
                  >
                    <div style={{ position: 'relative' }}>
                      <img src={logo} alt="Svila" className="img-fluid" width={100} style={{ marginLeft: 30 }} />
                      <WrapperUrl>
                        {/* <StyleP>staging</StyleP> */}
                        {PRODUCTION ? (
                          <StyleP background="none"></StyleP>
                        ) : STAGING ? (
                          <StyleP background="#0F6DF9">Staging</StyleP>
                        ) : (
                          <StyleP background="#8F0CF5">Local</StyleP>
                        )}
                      </WrapperUrl>
                    </div>
                  </NavLink>
                </Navbar.Brand>
                <Nav className="ml-auto" style={{ position: 'relative' }}>
                  <RolesDependent
                    roles={[
                      ROLES.ADMIN,
                      ROLES.SUPER_ADMIN,
                      ROLES.WAREHOUSE_ADMIN,
                      ROLES.WAREHOUSE,
                      ROLES.OFFICE,
                      ROLES.SALES,
                      ROLES.DATABASE_ADMIN,
                      ROLES.WAREHOUSE_EXTERNAL_USER,
                      ROLES.SVILA_CLIENT,
                      ROLES.SVILA_CLIENT_ADMIN
                    ]}
                  >
                    <NavItem number={1}>
                      <StyledNavDropdown title="Orders" id="basic-nav-dropdown">
                        <NavDropdown.Item onClick={() => setACtive(1)} as={NavLink} to="/orders-list">
                          Sell Orders
                        </NavDropdown.Item>
                        <NavDropdown.Item onClick={() => setACtive(1)} as={NavLink} to="/purchase-orders">
                          Purchase Orders
                        </NavDropdown.Item>
                        <RolesDependent
                          roles={[
                            ROLES.ADMIN,
                            ROLES.SUPER_ADMIN,
                            ROLES.WAREHOUSE_ADMIN,
                            ROLES.WAREHOUSE,
                            ROLES.OFFICE,
                            ROLES.SALES,
                            ROLES.DATABASE_ADMIN,
                          ]}
                        >
                          <NavDropdown.Item onClick={() => setACtive(1)} as={NavLink} to="/orders/fnb">
                            Fnb/Gomba Mirror Order
                          </NavDropdown.Item>
                          <NavDropdown.Item
                            onClick={() => setACtive(1)}
                            as={NavLink}
                            to="/orders/fnb-consolidations"
                          >
                            Fnb/Gomba Orders of kC Travel
                          </NavDropdown.Item>
                          <NavDropdown.Item onClick={() => setACtive(1)} as={NavLink} to="/orFnb Orders for Consolidationders/fnb-status">
                            Fnb Order Status
                          </NavDropdown.Item>
                        </RolesDependent>
                      </StyledNavDropdown>
                    </NavItem>
                  </RolesDependent>
                  <RolesDependent
                    roles={[
                      ROLES.ADMIN,
                      ROLES.SUPER_ADMIN,
                      ROLES.SALES,
                    ]}
                  >
                    <NavItem number={1}>
                      <StyledNavDropdown title="Invoices" id="basic-nav-dropdown">
                        <NavDropdown.Item onClick={() => setACtive(1)} as={NavLink} to="/invoices">
                          Cargoairbags
                        </NavDropdown.Item>
                        <NavDropdown.Item onClick={() => setACtive(1)} as={NavLink} to="/invoices/svila">
                          Svila
                        </NavDropdown.Item>
                        <NavDropdown.Item onClick={() => setACtive(1)} as={NavLink} to="/orders/fnb-invoices">
                          Fnb
                        </NavDropdown.Item>
                        <RolesDependent roles={[ROLES.ADMIN, ROLES.SUPER_ADMIN]}>
                          <NavDropdown.Item onClick={() => setACtive(1)} as={NavLink} to="/service-contracts">
                            Договори за услуги
                          </NavDropdown.Item>
                        </RolesDependent>
                      </StyledNavDropdown>
                    </NavItem>
                  </RolesDependent>
                  <RolesDependent
                    roles={[
                      ROLES.ADMIN,
                      ROLES.SUPER_ADMIN,
                      ROLES.WAREHOUSE_ADMIN,
                      ROLES.WAREHOUSE,
                      ROLES.OFFICE,
                      ROLES.SALES,
                      ROLES.DATABASE_ADMIN,
                      ROLES.WAREHOUSE_EXTERNAL_USER,
                      ROLES.SVILA_CLIENT,
                      ROLES.SVILA_CLIENT_ADMIN
                    ]}
                  >
                    <NavItem number={2}>
                      <StyledNavDropdown title="Warehouse" id="basic-nav-dropdown">
                        <RolesDependent
                          roles={[
                            ROLES.ADMIN,
                            ROLES.SUPER_ADMIN,
                            ROLES.WAREHOUSE_ADMIN,
                            ROLES.WAREHOUSE,
                            ROLES.OFFICE,
                            ROLES.SALES,
                            ROLES.DATABASE_ADMIN,
                            ROLES.WAREHOUSE_EXTERNAL_USER,
                          ]}
                        >
                          <NavDropdown.Item onClick={() => setACtive(2)} as={NavLink} to="/inventory">
                            Sevliveo New
                          </NavDropdown.Item>
                        </RolesDependent>
                        <RolesDependent
                          roles={[
                            ROLES.ADMIN,
                            ROLES.SUPER_ADMIN,
                            ROLES.WAREHOUSE_ADMIN,
                            ROLES.WAREHOUSE,
                            ROLES.OFFICE,
                            ROLES.SALES,
                            ROLES.DATABASE_ADMIN,
                            ROLES.SVILA_CLIENT_ADMIN,
                            ROLES.SVILA_CLIENT
                          ]}
                        >
                          <NavDropdown.Item onClick={() => setACtive(2)} as={NavLink} to="/warehouses">
                            Warehouses
                          </NavDropdown.Item>
                        </RolesDependent>
                      </StyledNavDropdown>
                    </NavItem>
                  </RolesDependent>
                  <RolesDependent
                    roles={[
                      ROLES.ADMIN,
                      ROLES.SUPER_ADMIN,
                      ROLES.WAREHOUSE_ADMIN,
                      ROLES.WAREHOUSE,
                      ROLES.OFFICE,
                      ROLES.SALES,
                      ROLES.DATABASE_ADMIN,
                    ]}
                  >
                    <NavItem number={3}>
                      <StyledNavDropdown title="Products" id="basic-nav-dropdown">
                        <NavDropdown.Item onClick={() => setACtive(3)} as={NavLink} to="/products">
                          All Products
                        </NavDropdown.Item>
                        <NavDropdown.Item onClick={() => setACtive(3)} as={NavLink} to="/brands">
                          Brand
                        </NavDropdown.Item>
                        {
                          // This code was comented out becouse was implimented another way to work with ingridients
                          /*
                          <NavDropdown.Item onClick={() => setACtive(3)} as={NavLink} to="/ingredients">
                            Ingredients
                          </NavDropdown.Item>
                          */
                        }
                        <NavDropdown.Item onClick={() => setACtive(3)} as={NavLink} to="/hscodes">
                          HS Codes
                        </NavDropdown.Item>
                        <NavDropdown.Item onClick={() => setACtive(3)} as={NavLink} to="/categories">
                          Categories
                        </NavDropdown.Item>
                        <NavDropdown.Item onClick={() => setACtive(3)} as={NavLink} to="/pallets">
                          Pallets
                        </NavDropdown.Item>
                        <NavDropdown.Item onClick={() => setACtive(3)} as={NavLink} to="/containers">
                          Containers
                        </NavDropdown.Item>
                        <NavDropdown.Item onClick={() => setACtive(3)} as={NavLink} to="/trucks">
                          Trucks
                        </NavDropdown.Item>
                        <NavDropdown.Item onClick={() => setACtive(3)} as={NavLink} to="/packages">
                          Packages
                        </NavDropdown.Item>
                        <NavDropdown.Item onClick={() => setACtive(3)} as={NavLink} to="/labels">
                          Labels
                        </NavDropdown.Item>
                        <NavDropdown.Item onClick={() => setACtive(3)} as={NavLink} to="/storage-conditions">
                          Storage Conditions
                        </NavDropdown.Item>
                      </StyledNavDropdown>
                    </NavItem>
                  </RolesDependent>
                  <RolesDependent
                    roles={[
                      ROLES.ADMIN,
                      ROLES.SUPER_ADMIN,
                      ROLES.WAREHOUSE_ADMIN,
                      ROLES.WAREHOUSE,
                      ROLES.OFFICE,
                      ROLES.SALES,
                      ROLES.DATABASE_ADMIN,
                      ROLES.SVILA_CLIENT,
                      ROLES.SVILA_CLIENT_ADMIN
                    ]}>
                    <NavItem number={4}>
                      <StyledNavDropdown title="Contractors" id="basic-nav-dropdown">
                        <RolesDependent
                          roles={[
                            ROLES.ADMIN,
                            ROLES.SUPER_ADMIN,
                            ROLES.WAREHOUSE_ADMIN,
                            ROLES.WAREHOUSE,
                            ROLES.OFFICE,
                            ROLES.SALES,
                            ROLES.DATABASE_ADMIN
                          ]}>
                          <NavDropdown.Item onClick={() => setACtive(4)} as={NavLink} to="/manufacturers">
                            Manufacturers
                          </NavDropdown.Item>
                        </RolesDependent>
                        <NavDropdown.Item onClick={() => setACtive(4)} as={NavLink} to="/suppliers">
                          Suppliers
                        </NavDropdown.Item>
                        <NavDropdown.Item onClick={() => setACtive(4)} as={NavLink} to="/customers">
                          Customers
                        </NavDropdown.Item>
                        <NavDropdown.Item onClick={() => setACtive(4)} as={NavLink} to="/warehouse-owners">
                          Warehouse Owners
                        </NavDropdown.Item>
                      </StyledNavDropdown>
                    </NavItem>
                  </RolesDependent>
                  <RolesDependent
                    roles={[
                      ROLES.ADMIN,
                      ROLES.SUPER_ADMIN,
                      ROLES.WAREHOUSE_ADMIN,
                      ROLES.WAREHOUSE,
                      ROLES.OFFICE,
                      ROLES.SALES,
                      ROLES.DATABASE_ADMIN,
                    ]}
                  >
                    <NavItem number={5}>
                      <StyledNavDropdown title="Other" id="basic-nav-dropdown">
                        <NavDropdown.Item onClick={() => setACtive(5)} as={NavLink} to="/transport-pricings">
                          Transport Pricing
                        </NavDropdown.Item>
                        <NavDropdown.Item onClick={() => setACtive(5)} as={NavLink} to="/margins">
                          Margins
                        </NavDropdown.Item>
                        <NavDropdown.Item onClick={() => setACtive(5)} as={NavLink} to="/nutrition">
                          Nutrition
                        </NavDropdown.Item>
                        <RolesDependent roles={[ROLES.ADMIN, ROLES.SUPER_ADMIN]}>
                          <NavDropdown.Item onClick={() => setACtive(5)} as={NavLink} to="/warehouse-chambers">
                            Warehouse Chambers
                          </NavDropdown.Item>
                        </RolesDependent>
                      </StyledNavDropdown>
                    </NavItem>
                  </RolesDependent>
                  <RolesDependent
                    roles={[
                      ROLES.ADMIN,
                      ROLES.SUPER_ADMIN,
                      ROLES.SVILA_CLIENT_ADMIN
                    ]}
                  >
                    <NavItem number={6}>
                      <Nav.Link onClick={() => setACtive(6)} as={NavLink} to="/users">
                        Users
                      </Nav.Link>
                    </NavItem>
                  </RolesDependent>
                  <RolesDependent
                    roles={[
                      ROLES.ADMIN,
                      ROLES.SUPER_ADMIN,
                      ROLES.WAREHOUSE_ADMIN,
                      ROLES.WAREHOUSE,
                      ROLES.OFFICE,
                      ROLES.SALES,
                      ROLES.DATABASE_ADMIN,
                    ]}
                  >
                    <NavItem number={7}>
                      <Nav.Link onClick={() => setACtive(7)} as={NavLink} to="/data-operations">
                        Data Operations
                      </Nav.Link>
                    </NavItem>
                  </RolesDependent>
                  <RolesDependent
                    roles={[ROLES.ADMIN,
                    ROLES.SUPER_ADMIN,
                    ]}>
                    <NavItem number={8}>
                      <Nav.Link onClick={() => setACtive(8)} as={NavLink} to="/svila-clients">
                        Svila Clients
                      </Nav.Link>
                    </NavItem>
                  </RolesDependent>
                  <RolesDependent roles={[ROLES.WAREHOUSE_EXTERNAL_USER]}>
                    <NavItem number={2}>
                      <Nav.Link onClick={() => setACtive(2)} as={NavLink} to="/customers">
                        Customers
                      </Nav.Link>
                    </NavItem>
                  </RolesDependent>
                </Nav>
              </StyledNavbarColapse>
              {/* {user?.isAuthenticated === true ? ( */}
              <CustomNavDropdown pullLeft title={<img src={userIcon} alt="User Icon" />} id="basic-nav-dropdown">
                <NavDropdown.Item as={NavLink} to="/profile">
                  Profile
                </NavDropdown.Item>
                <NavDropdown.Item onClick={() => logout()}>Logout</NavDropdown.Item>
              </CustomNavDropdown>
              {/* ) : (
            <NavDropdown.Item as={NavLink} to="/login">
              Login
            </NavDropdown.Item>
          )} */}
            </StyledNavbar>
          )}
        </>
      )
      }
    </MyContext.Consumer >
  );
}

const WrapperNavLink = styled.div`
  ${({ isActive }) =>
    isActive &&
    ` 
      a.nav-link {
        color: ${Colors.darkBrown} !important;
      }
    `}
`;

const StyleP = styled.p`
  padding: 2px 8px;
  margin: 0;
  font-size: 12px;
  line-height: 12px;
  border-radius: 5px;
  background: ${(props) => props.background};
  color: #fff;
`;

const WrapperUrl = styled.div`
  position: absolute;
  bottom: -4px;
  right: 55px;
`;

const MaskGroupWrapper = styled.div`
  @media (max-width: 992px) {
    display: none;
  }
  height: 73px;
  width: 100%;
  overflow: hidden;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 0;
`;

const MaskGroupImage = styled.img`
  position: absolute;
  top: -60px;
  left: -110px;
  z-index: 0;
`;

const CustomNavDropdown = styled(NavDropdown)`
  @media (max-width: 992px) {
    display: none;
  }
  .dropdown::after {
    display: none !important;
  }
  .dropdown-toggle::after {
    display: none !important;
  }
  && .dropdown-toggle::after {
    display: none;
  }

  && img {
    border-radius: 50%;
    padding: 10px;
    background-color: #642b26;
    transition: background-color 0.2s;
  }

  && img:hover {
    background-color: #642b26;
  }
  .dropdown-menu {
    background-color: #642b26;
    border-radius: 10px;
    left: -70px !important;
  }
`;

const StyledNavbar = styled(Navbar)`
  .navbar-toggler {
    margin: 15px;
  }
  padding: 0;
  margin: 0;
  && .dropdown-toggle {
    padding-right: 28px !important;
  }
  && .dropdown-toggle::after {
    position: absolute;

    top: 50%;
    right: 16px;

    transform: translateY(-50%);
    background-image: url(${arrow}) !important;
    background-size: cover !important;
    height: 6px !important;
    width: 13px !important;
    background-repeat: no-repeat;
    border-top: 0 !important;
  }
  .dropdown-menu {
    background-color: #642b26;
    border-radius: 10px;
  }
  .nav-link {
    color: #fff !important;
  }
  a.dropdown-item.active {
    color: #ef7d00 !important;
    background: transparent;
  }
  .dropdown-item {
    color: white;
    &:hover {
      background-color: transparent;
      color: white;
      text-decoration: none;
    }
  }
  .nav-link {
    position: relative;
    height: 73px;
    display: flex;
    align-items: center;
    padding-right: 28px !important;
    @media (max-width: 992px) {
      padding: 15px !important;
    }
    &:hover {
      && .dropdown-toggle::before {
        @media (min-width: 992px) {
          content: '';
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          background: ${Colors.darkBrown};
          height: 3px;
        }
      }
    }
  }

  a.dropdown-item.active {
    color: #ef7d00 !important;
    background: transparent;
  }
`;

const StyledNavDropdown = styled(NavDropdown)`
  && .dropdown-toggle::after {
    background-image: url(${arrow});
    background-size: contain;
    height: 5px;
    width: 5px;
  }
  height: 100%;
  @media (min-width: 992px) {
    height: 73px;
    display: flex;
    align-items: center;
  }
  position: relative;
  &:hover {
    && .dropdown-toggle::before {
      @media (min-width: 992px) {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        background: ${Colors.darkBrown};
        height: 3px;
      }
    }
  }
`;

const StyledNavbarColapse = styled(Navbar.Collapse)`
  position: relative;
  background: #ef7d00;
  background-size: cover;
  height: 100%;
  @media (min-width: 992px) {
    border-top-right-radius: 50px;
    border-bottom-right-radius: 50px;
    height: 73px;
    display: flex;
    align-items: center;
  }
  width: 100%;
  .navlink.active + div a:first-of-type {
    color: red;
  }
  a.dropdown-item.active + .nav-link {
    color: red !important;
    background: red !important;
  }
  .dropdown-menu {
    background-color: #642b26;
    border-radius: 10px;
  }
`;
